import React, { useState } from 'react';
import { Button, TextField, Box, Typography, Container } from '@mui/material';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { getEnv } from "../libs/global";

const Restart = () => {
    const [email, setEmail] = useState('');
    const [token, setToken] = useState('');
    const [enteredToken, setEnteredToken] = useState(''); // Token ingresado por el usuario
    const [password, setPassword] = useState('');
    const [isTokenVerified, setIsTokenVerified] = useState(false);
    const [error, setError] = useState('');
    const navigate = useNavigate();
    const envel = getEnv();

    const handleReset = async (e) => {
        e.preventDefault();
        try {
            const response = await axios.post(`${envel.url}/backComerbasPHP/public/index.php`, {
                action: 'resetPass',
                email,
            });
            const data = response.data;
            if (data.status === 'success') {
                setToken(data.token);  // Guardar el token recibido en el estado
                setError('');
            } else {
                setError(data.message);
            }
        } catch (error) {
            setError('Error en el servidor, intenta más tarde.');
        }
    };

    const verifyToken = () => {
        if (enteredToken === token) {

            setIsTokenVerified(true);
            setError('');
        } else {
            setError('El token ingresado no es correcto. Verifícalo e intenta de nuevo.');
        }
    };

    const handlePasswordUpdate = async () => {
        try {
            const response1 = await axios.post(`${envel.url}/backComerbasPHP/public/index.php`, {
                action: 'updatePassword',
                email,
                password
            });
            const data = response1.data;
            if (data.status === 'success') {
                setError('Contraseña actualizada con éxito.');
                navigate('/');  // Redirige a la página de inicio de sesión
            } else {
                setError(data.message);
            }
        } catch (error) {
            setError('Error en el servidor, intenta más tarde.');
        }
    };

    return (
        <Container component="main" maxWidth="xs">
            <Box
                sx={{
                    marginTop: 8,
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                }}
            >
                <Typography component="h1" variant="h5">
                    Restablecer Contraseña
                </Typography>

                {error && (
                    <Typography color="error" variant="body2" sx={{ mt: 2 }}>
                        {error}
                    </Typography>
                )}

                <Box component="div" sx={{ mt: 1 }}>
                    {!token ? (
                        <>
                            <TextField
                                margin="normal"
                                required
                                fullWidth
                                id="email"
                                label="Correo Electrónico"
                                name="email"
                                autoComplete="email"
                                autoFocus
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                            />
                            <Button
                                fullWidth
                                variant="contained"
                                sx={{ mt: 3, mb: 2 }}
                                onClick={handleReset}
                            >
                                Enviar
                            </Button>
                        </>
                    ) : !isTokenVerified ? (
                        <>
                            <TextField
                                margin="normal"
                                required
                                fullWidth
                                id="enteredToken"
                                label="Token de Verificación"
                                name="enteredToken"
                                value={enteredToken}
                                onChange={(e) => setEnteredToken(e.target.value)}
                            />
                            <Button
                                fullWidth
                                variant="contained"
                                sx={{ mt: 3, mb: 2 }}
                                onClick={verifyToken}
                            >
                                Verificar Token
                            </Button>
                        </>
                    ) : (
                        <>
                            <TextField
                                margin="normal"
                                required
                                fullWidth
                                id="password"
                                label="Nueva Contraseña"
                                name="password"
                                type="password"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                            />
                            <Button
                                fullWidth
                                variant="contained"
                                sx={{ mt: 3, mb: 2 }}
                                onClick={handlePasswordUpdate}
                            >
                                Actualizar Contraseña
                            </Button>
                        </>
                    )}
                </Box>
            </Box>
        </Container>
    );
};

export default Restart;
